export default {
  roundness: 4,
  colors: {
    primary: '#44EB8D',
    primaryDark: '#3FC77A',
    primaryDarker: '#28a428',
    error: '#E74C3C',
    shadowColor: '#000',
    transParentColor: 'transparent',
    red: '#ff0000cc',
    parrotGreen: '#82c713',
    // Text
    primaryText: '#081B22',
    secondaryText: '#658481',
    emptyStateText: '#B8B8B8',
    disableText: '#658481',
    // Backgrond
    primaryBg: '#FFFFFF',
    emptyStateBg: '#F5F5F5',
    emptyStateLightBg: '#F8F8F8',
    lightGreenBg: '#F1FAF5',
    infoBg: '#164EC3',
    // Icon
    iconTint: '#3FC77A',
    secondaryIconColor: '#373E38',
    // Border
    borderColor: '#D5E8EF',
    // activate
    activeColor: '#FF1717',
    dotColor: '#E2F2E9',
    // switch
    disableBg: '#ECECEC',
    cardBorderColor: '#d3d3d3',
    cardPlaceHolderColor: '#808080',
    // search section
    sectionDate: '#F1FAF580',
    blockSlotColor: '#EEEEEE',
    borderGrey: '#A9A9A9',
    lightDanger: '#ffc9c9'
  },
  fonts: {
    regular: {
      fontFamily: 'Cera Pro Light'
    },
    medium: {
      fontFamily: 'Cera Pro Medium'
    },
    bold: {
      fontFamily: 'Cera Pro Bold'
    },
    signature1: {
      fontFamily: 'MrDafoe-Regular'
    },
    signature2: {
      fontFamily: 'MrsSaintDelafield-Regular'
    },
    signature3: {
      fontFamily: 'Sail-Regular'
    }
  },
  gradient: {
    primary: 'linear-gradient(97.57deg, #89E141 -27.78%, #29E6CE 112.55%)'
  }
};
